import { computed } from 'mobx';

export default class ParameterUnitModel {
  id;
  store;

  constructor(store, parameter) {
    this.store = store;
    this.id = +parameter.id;
    this.name = parameter.name;
    this.symbol = parameter.symbol;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      symbol: this.symbol,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.symbol = json.symbol;
  }
}



// WEBPACK FOOTER //
// ./src/models/ParameterUnitModel.js